export const trOpeningHours = {
	DE: 'Unsere Öffnungszeiten',
	EN: 'Opening Hours',
	// prettier-ignore
	FR: 'Heures d\'ouverture',
};
